import { gql } from '@edreamsodigeo/frontend-api-client';

const GET_TRIP_QUERY = gql`
  query AP_GetTrip($token: String!) {
    getTripByToken(token: $token) {
      trip {
        buyer {
          lastNames
          country
          zipCode
          cpf
          address
          cityName
          stateName
          dateOfBirth
          name
          mail
          phoneNumber {
            countryCode
            number
          }
        }
      }
    }
  }
`;

export default GET_TRIP_QUERY;
